import { UseMicrobiomeAgeResponse } from 'services/microbiome/types/microbiome-age.types';

export default function groupMicrobiomeAge(
  microbiomeAge: UseMicrobiomeAgeResponse,
) {
  const rollups = microbiomeAge.filter(r => r.key_insights_section_id != null);
  const drivers = microbiomeAge.filter(r => r.sample_health_id != null);

  const sections = rollups.map(rollup => ({
    section: rollup.key_insights_section,
    contribution_years: rollup.contribution_years,
    collapsed_count: rollup.collapsed_count,
    metrics: drivers.filter(
      d =>
        d.gut_vaginal_health?.key_insights_category?.section_id ===
        rollup.key_insights_section_id,
    ),
  }));

  return sections;
}

export type GroupedMicrobiomeAge = ReturnType<typeof groupMicrobiomeAge>;
export type Metrics = GroupedMicrobiomeAge[number]['metrics'];
